<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 31 31"
    fill="none"
    v-bind="$attrs"
    :width="width"
    :height="width"
  >
    <path
      d="M27.1688 0H3.01875C1.35391 0 0 1.69239 0 3.77344V26.4141C0 28.4951 1.35391 30.1875 3.01875 30.1875H27.1688C28.8336 30.1875 30.1875 28.4951 30.1875 26.4141V3.77344C30.1875 1.69239 28.8336 0 27.1688 0ZM6.79219 5.66016C7.39265 5.66016 7.96853 5.95832 8.39312 6.48907C8.81772 7.01981 9.05625 7.73965 9.05625 8.49023C9.05625 9.24082 8.81772 9.96066 8.39312 10.4914C7.96853 11.0221 7.39265 11.3203 6.79219 11.3203C6.19172 11.3203 5.61585 11.0221 5.19125 10.4914C4.76666 9.96066 4.52813 9.24082 4.52813 8.49023C4.52813 7.73965 4.76666 7.01981 5.19125 6.48907C5.61585 5.95832 6.19172 5.66016 6.79219 5.66016ZM15.0938 24.5273H4.52813L10.5656 15.0938L12.8297 18.8672L17.3578 11.3203L25.6594 24.5273H15.0938Z"
      :fill="fill"
    />
  </svg>
</template>

<script lang="ts" setup>
defineProps({
  width: {
    type: [String, Number],
    default: 31,
  },
  height: {
    type: [String, Number],
    default: 31,
  },
  fill: {
    type: String,
    default: '#E51E25',
  }
});
</script>